import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import PlotDetail from './pages/PlotDetail';
import BuildingDetail from './pages/BuildingDetail';
import IFCViewer from './pages/IfcViewer';
import Users from './pages/Users';
import Customers from './pages/Customers';

const App: React.FC = () => {
  const isAuthenticated = () => !!localStorage.getItem('token');

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={isAuthenticated() ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/projects" element={isAuthenticated() ? <Projects /> : <Navigate to="/login" />} />
        <Route path="/projects/:id" element={isAuthenticated() ? <ProjectDetail /> : <Navigate to="/login" />} />
        <Route path="/plots/:id" element={isAuthenticated() ? <PlotDetail /> : <Navigate to="/login" />} />
        <Route path="/buildings/:id" element={isAuthenticated() ? <BuildingDetail /> : <Navigate to="/login" />} />
        <Route path="/viewer" element={isAuthenticated() ? <IFCViewer /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to={isAuthenticated() ? "/dashboard" : "/login"} />} />
        <Route path="/users" element={isAuthenticated() ? <Users /> : <Navigate to="/login" />} />
        <Route path="/customers" element={isAuthenticated() ? <Customers /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;